import { motion } from "framer-motion";
import { Truck, ShieldCheck, Globe, Tag, Lightning } from "@phosphor-icons/react";
import { useLang } from "../i18n/LanguageContext";

const icons = [Truck, ShieldCheck, Globe, Tag, Lightning];

export default function WhyChooseUs() {
  const { t } = useLang();
  const items = [1, 2, 3, 4, 5].map((n, i) => ({
    icon: icons[i],
    title: t(`why.r${n}Title`),
    text: t(`why.r${n}Text`),
  }));
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-20 md:py-28 bg-white border-y border-[#D5DEE8]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14">
        <div className="text-center mb-12 md:mb-16">
          <p className="overline-maroon mb-4">{t("why.overline")}</p>
          <h2 className="font-serif-display font-light text-3xl sm:text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#0F1E33]">
            {t("why.title1")} <span className="text-[#1E3A5F] italic">{t("why.titleItalic")}</span>
          </h2>
          <div className="mx-auto mt-6 w-24 hairline-gold" />
          <p className="mt-6 max-w-2xl mx-auto text-[#4A5A70] text-base md:text-lg leading-relaxed">
            {t("why.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {items.map((it, idx) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                data-testid={`why-card-${idx}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.5, delay: idx * 0.08 }}
                className="group bg-white border border-[#D5DEE8] p-6 md:p-7 hover:border-[#B8860B] transition-colors text-center"
              >
                <div className="inline-flex items-center justify-center w-14 h-14 mx-auto mb-5 border border-[#B8860B]/40 bg-[#C9D9EC] text-[#1E3A5F] group-hover:bg-[#D4AF37] group-hover:text-[#0F1E33] transition-colors">
                  <Icon size={26} weight="duotone" />
                </div>
                <h3 className="font-serif-display text-xl md:text-2xl text-[#0F1E33] tracking-tight mb-3">
                  {it.title}
                </h3>
                <p className="text-sm md:text-base text-[#4A5A70] leading-relaxed">
                  {it.text}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
